<template>
  <div class="content">
    <!--列表-->
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>资讯管理</el-breadcrumb-item>
      </el-breadcrumb>
      <el-row type="flex" :gutter="20">
        <el-col :span="1" v-if="$utils.checkPer('car-activities.store')">
          <el-button type="primary" size="mini" @click="addData"
            >新增</el-button
          >
        </el-col>

        <el-col :span="3">
          <el-input
            v-model="where.activities_name"
            style="width: 200px"
            placeholder="活动名称"
            clearable
            size="mini"
          ></el-input>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" @click="index(where)" size="mini"
            >查询</el-button
          >
        </el-col>
      </el-row>
      <el-row style="margin-top: 15px">
        <el-table
          v-loading="loading"
          border
          height="650"
          :data="tableData"
          style="width: 100%; margin-bottom: 10px"
        >
          <el-table-column
            type="index"
            width="50"
            fixed
            label="序号"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="activities_name"
            label="活动名称"
            align="center"
          >
            <template slot-scope="scope">
              <div class="overflowTXT">
                {{ scope.row.activities_name }}
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="activities_logo"
            align="center"
            label="封面"
            width="150"
          >
            <template slot-scope="scope">
              <el-image
                :src="$utils.isImgUrl(scope.row.activities_logo)"
                :preview-src-list="$utils.isImgList(scope.row.activities_logo)"
              ></el-image>
            </template>
          </el-table-column> -->

          <!-- <el-table-column
            prop="activities_addr"
            label="活动地址"
            align="center"
          >
          </el-table-column> -->

          <el-table-column
            prop="activities_start_time"
            label="开始时间"
            align="center"
          >
            <template slot-scope="scope">
              {{ $utils.isDate(scope.row.activities_start_time) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="activities_end_time"
            label="结束时间"
            align="center"
          >
            <template slot-scope="scope">
              {{ $utils.isDate(scope.row.activities_end_time) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="activities_hot"
            align="center"
            label="热门活动"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.activities_hot | getHot }}</span>
            </template>
          </el-table-column>
          <!--                    <el-table-column
                            prop="activities_type"
                            align="center"
                            label="活动类型">
                    </el-table-column>-->
          <el-table-column
            prop="activities_summary"
            align="center"
            label="活动摘要"
          >
            <template slot-scope="scope">
              <div class="overflowTXT">
                {{ scope.row.activities_summary }}
              </div>
            </template>
          </el-table-column>

          <!-- <el-table-column
            prop="activities_con"
            align="center"
            label="活动内容"
            width="150"
          >
            <template slot-scope="scope">
              <el-tag>{{
                scope.row.activities_con
                  ? scope.row.activities_con.substring(0, 10) + "..."
                  : ""
              }}</el-tag>
            </template>
          </el-table-column> -->
          <el-table-column prop="address" align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                size="small"
                v-if="$utils.checkPer('car-activities.store')"
                @click="editMessage(scope.row)"
                type="primary"
                plain
                >修改</el-button
              >
              <el-button
                size="small"
                v-if="$utils.checkPer('car-activities.store')"
                @click="delMessage(scope.row)"
                type="danger"
                plain
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="index(where)"
          :current-page.sync="where.page"
          :page-size="where.pagesize"
          :page-sizes="[10, 20, 50, 100]"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-row>
    </div>

    <!-- 添加修改 -->
    <el-dialog
      title="资讯管理"
      :visible.sync="dialogVisible"
      width="90%"
      :before-close="handleClose"
      v-if="dialogVisible"
    >
      <myForm
        @carActivities="oncarActivities"
        :edit="isupdata"
        :row="updataList"
      ></myForm>
    </el-dialog>
  </div>
</template>

<script>
// 添加 点赞 浏览量
import {
  carActivitiesList,
  addcarActivitiesList,
  modifycarActivitiesList,
  delcarActivitiesList,
} from "../../api/api";
import env from "../../env";
import myForm from "./form";
import lrz from "lrz";
export default {
  name: "car-activities",
  data() {
    return {
      tableData: [],
      keyword: [],
      loading: false,
      where: {
        activities_name: "",
        page: 1,
        pagesize: 10,
      },
      total: 0,
      dialogVisible: false,
      isupdata: false,
      updataList: "",
      isupdataid: 0,
    };
  },
  components: {
    myForm,
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取列表
    getList() {
      this.loading = true;
      carActivitiesList(this.where).then((msg) => {
        let { data } = msg;
        data = JSON.parse(data).data;
        this.tableData = data.data;
        this.total = data.total;
        this.loading = false;
      });
    },
    // 添加
    addData() {
      this.dialogVisible = true;
    },
    oncarActivities(obj) {
      if (obj.form) {
        this.baseUrl(obj.form);
      }
      this.dialogVisible = false;
      this.isupdata = false;
      this.updataList = "";
      this.isupdataid = 0;
    },
    // 编辑
    editMessage(scope) {
      this.dialogVisible = true;
      this.isupdata = true;
      this.updataList = scope;
      this.isupdataid = scope.id;
    },
    // 删除
    delMessage(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delcarActivitiesList(row.id).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
              this.getList();
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.where.pagesize = val;
      this.getList();
    },
    index(e) {
      this.where = e;
      this.getList();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 修改base64为url
    baseUrl(form) {
      if (this.isupdata == false) {
        addcarActivitiesList(form).then((msg) => {
          let { data } = msg;
          data = JSON.parse(data);
          if (data.code == 200) {
            this.$message.success(data.msg);
            this.getList();
          } else {
            this.$message.error(data.msg);
          }
        });
      }
      if (this.isupdata == true) {
        modifycarActivitiesList(this.isupdataid, form).then((msg) => {
          let { data } = msg;
          data = JSON.parse(data);
          if (data.code == 200) {
            this.$message.success(data.msg);
            this.getList();
            this.isupdata = false
          } else {
            this.$message.error(data.msg);
            this.isupdata = false
          }
        });
      }
    },
  },
  filters: {
    getImg: function (value) {
      if (value == "[]" || value == null || value == "") return "";
      if (value.indexOf("bannerImg") != -1) {
        //调用汽车出口价旧图片
        //let url = window.location.origin+'/'+ value;
        let url = "https://api.zhenbaojia.cn/" + value;
        return url;
      }
      let res = eval("(" + value + ")");
      let url = window.location.origin + "/" + res[0].response.path;
      return url;
    },
    getImgArr: function (value) {
      if (value == "[]" || value == null || value == "") return [];
      if (value.indexOf("bannerImg") != -1) {
        //调用汽车出口价旧图片
        let url = [];
        url.push("https://api.zhenbaojia.cn/" + value);
        return url;
      }
      let res = JSON.parse(value);
      if (typeof res[0].response == "undefined") return [];
      let url = [];
      url.push(window.location.origin + "/" + res[0].response.path);
      return url;
    },
    getText: function (value) {
      if (!value || value == "") return "";
      let res_json = JSON.parse(value);
      let res = "";
      for (var i = 0; i < res_json.length; i++) {
        res += res_json[i] + "\n";
      }
      console.log(res);
      return res;
    },
    getHot: function (value) {
      //if (!value || value == '') return '';
      if (value) {
        return "是";
      } else {
        return "否";
      }
    },
    getType: function (value) {
      //if (!value || value == '') return '';
      if (value) {
        return "活动";
      } else {
        return "资讯";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.el-col-3 {
  width: 210px;
}
.el-col-1 {
  width: 68px;
}
.el-breadcrumb {
  margin-bottom: 15px;
}
// 设置超出吟唱
.overflowTXT {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
